import React from "react";
import PropTypes from "prop-types";
import RatingEmoji from "./RatingEmoji";
import {
  RatingStepWrapper,
  Title,
  ReviewTitle,
  Rating,
  Input,
  Label,
  StepCount,
} from "../styles/form-steps-styles";

const ProfessionalismStep = ({
  setRating,
  rating,
  recruiterName,
  agencyName,
}) => (
  <RatingStepWrapper noPointerEvents={rating}>
    <Title data-test-id="step2-rating-title">
      Please leave a review for <strong>{recruiterName}</strong> at{" "}
      <strong>{agencyName}</strong>
    </Title>
    <RatingEmoji rating={rating} />
    <ReviewTitle
      className="animated fadeIn delay-1"
      data-test-id="step2-review-title"
    >
      Professionalism
    </ReviewTitle>
    <Rating className="rating animated fadeIn delay-2">
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="professionalismRating"
        id="rating-15"
        value={5}
        data-test-id="step-rating-input"
      />
      <Label htmlFor="rating-15" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="professionalismRating"
        id="rating-14"
        value={4}
      />
      <Label htmlFor="rating-14" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="professionalismRating"
        id="rating-13"
        value={3}
      />
      <Label htmlFor="rating-13" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="professionalismRating"
        id="rating-12"
        value={2}
      />
      <Label htmlFor="rating-12" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="professionalismRating"
        id="rating-11"
        value={1}
      />
      <Label htmlFor="rating-11" />
    </Rating>
    <StepCount data-test-id="step-count">step 2 of 5</StepCount>
  </RatingStepWrapper>
);

ProfessionalismStep.propTypes = {
  setRating: PropTypes.func.isRequired,
  recruiterName: PropTypes.string.isRequired,
  agencyName: PropTypes.string.isRequired,
  rating: PropTypes.number,
};

ProfessionalismStep.defaultProps = {
  rating: PropTypes.isNull,
};

export default ProfessionalismStep;
